<!-- Widok desktopowy - tabela -->
<div class="desktop-view">
  <!-- Tabela z danymi -->
  <div *ngIf="dane && dane.length > 0">
    <ngx-datatable
      class="bootstrap"
      [rows]="dane"
      [summaryRow]="true"
      [summaryPosition]="'bottom'"
      [headerHeight]="45"
      [rowHeight]="45"
      [footerHeight]="50"
      [columnMode]="'flex'"
      [messages]="komunikatyTabeli"
      [limit]="15"
    >
    <ngx-datatable-column 
      prop="okres"
      name="{{ 'etykieta.okres' | translate }}"
      cellClass="text-center"
      [flexGrow]="2"
      [headerTemplate]="hdrTpl"
      [comparator]="sortujPoOkresie"
    >
    </ngx-datatable-column>

    <ngx-datatable-column 
      prop="rodzaj"
      name="{{ 'etykieta.rodzaj' | translate }}"
      cellClass="text-center"
      [flexGrow]="2"
      [headerTemplate]="hdrTpl"
    >
      <ng-template let-value="value" ngx-datatable-cell-template>
        {{ value | translate }}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column 
      prop="kwota"
      name="{{ 'etykieta.kwota' | translate }}"
      cellClass="text-right"
      [flexGrow]="2"
      [headerTemplate]="hdrTpl"
      [summaryFunc]="sumaKwota"
    >
      <ng-template let-value="value" ngx-datatable-cell-template>
        {{value | kwota}}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column 
      prop="terminPlatnosci"
      name="{{ 'etykieta.termin-platnosci' | translate }}"
      cellClass="text-center"
      [flexGrow]="2"
      [headerTemplate]="hdrTpl"
    >
      <ng-template let-value="value" ngx-datatable-cell-template>
        {{ value | date:'dd.MM.yyyy':'pl' }}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column 
      prop="uwagi"
      name="{{ 'etykieta.uwagi' | translate }}"
      cellClass="text-center"
      [flexGrow]="3"
      [headerTemplate]="hdrTpl"
    >
    </ngx-datatable-column>
    </ngx-datatable>
  </div>

  <!-- Komunikat o braku danych -->
  <div *ngIf="!dane || dane.length === 0" class="text-center py-5">
    <nb-icon icon="info-outline" class="mb-3" style="font-size: 3rem; color: #8f9bb3;"></nb-icon>
    <p class="text-hint mb-0" style="font-size: 1.1rem;">{{ 'komunikat.brak-danych-zus' | translate }}</p>
  </div>
</div>

<!-- Widok mobilny - kafelki -->
<div class="mobile-view">
  <!-- Filtr dla widoku mobilnego -->
  <div class="mobile-filter mb-3" *ngIf="wyswietlanieFiltrow">
    <input
      nbInput
      fullWidth
      type="search"
      placeholder="{{ 'etykieta.szukaj' | translate }}"
      (input)="updateFilterMobile($event)"
    />
  </div>

  <!-- Kafelki z danymi -->
  <div class="row" *ngIf="dane && dane.length > 0">
    <div class="col-12 mb-3" *ngFor="let item of dane; let i = index">
      <nb-card>
        <nb-card-header>
          <div class="d-flex justify-content-between align-items-center">
            <span class="font-weight-bold">{{ item.okres }}</span>
            <span class="text-muted">#{{ item.liczbaPorzadkowa }}</span>
          </div>
        </nb-card-header>
        <nb-card-body>
          <div class="row mb-2">
            <div class="col-6">
              <div class="stat-label">{{ 'etykieta.rodzaj' | translate }}</div>
              <div class="stat-value">{{ item.rodzaj | translate }}</div>
            </div>
            <div class="col-6">
              <div class="stat-label">{{ 'etykieta.kwota' | translate }}</div>
              <div class="stat-value text-primary font-weight-bold">{{ item.kwota | kwota }}</div>
            </div>
          </div>
          <div class="row mb-2" *ngIf="item.terminPlatnosci">
            <div class="col-12">
              <div class="stat-label">{{ 'etykieta.termin-platnosci' | translate }}</div>
              <div class="stat-value">{{ item.terminPlatnosci | date:'dd.MM.yyyy':'pl' }}</div>
            </div>
          </div>
          <div class="row" *ngIf="item.uwagi">
            <div class="col-12">
              <div class="stat-label">{{ 'etykieta.uwagi' | translate }}</div>
              <div class="stat-value">{{ item.uwagi }}</div>
            </div>
          </div>
        </nb-card-body>
      </nb-card>
    </div>
  </div>

  <!-- Komunikat o braku danych -->
  <div class="row" *ngIf="!dane || dane.length === 0">
    <div class="col-12">
      <nb-card accent="basic">
        <nb-card-body class="text-center">
          <nb-icon icon="info-outline" class="mb-2" style="font-size: 2rem; color: #8f9bb3;"></nb-icon>
          <p class="mb-0 text-hint">{{ 'komunikat.brak-danych-zus' | translate }}</p>
        </nb-card-body>
      </nb-card>
    </div>
  </div>

  <!-- Podsumowanie dla widoku mobilnego -->
  <nb-card accent="info" *ngIf="dane && dane.length > 0">
    <nb-card-header>
      <span class="font-weight-bold">{{ 'etykieta.podsumowanie' | translate }}</span>
    </nb-card-header>
    <nb-card-body>
      <div class="row">
        <div class="col-12 text-center">
          <div class="stat-label">{{ 'etykieta.suma-kwot' | translate }}</div>
          <div class="stat-value text-primary font-weight-bold" style="font-size: 1.5rem;">{{ sumaKwot() | kwota }}</div>
        </div>
      </div>
    </nb-card-body>
  </nb-card>
</div>

<ng-template #hdrTpl let-column="column" let-sort="sortFn">
  <span class="font-weight-bold" (click)="sort()">{{ column.name }}</span>
  <span [hidden] = "!wyswietlanieFiltrow">
    <br/>
    <input
      nbInput
      fieldSize="small"
      type="search"
      class="w-75"
      (input)="updateFilter($event, column.prop)"
    />
  </span>
</ng-template>